export default "__VITE_ASSET__C0IqRfIl__"